import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

const CLASS_PREFIX = 'product-image-modal';

const LightboxZoomModal = (props) => {
  const { images, currentImage, onClose, onClickThumbnail } = props;

  const handleKeyPress = (event) => {
    if (event.keyCode === 27) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!images || images.length === 0) return null;

  return (
    <div className={CLASS_PREFIX}>
      <div className={`${CLASS_PREFIX}__close`} onClick={onClose} />
      <div className={`${CLASS_PREFIX}__content`}>
        <Carousel
          onClickThumb={(index) => onClickThumbnail(index)}
          onChange={(index) => onClickThumbnail(index)}
          selectedItem={currentImage}
          showThumbs={true}
          showStatus={true}
          showIndicators={false}
          showArrows={true}
        >
          {images.map((image, index) => (
            <figure className={`${CLASS_PREFIX}__image`} key={index}>
              <img
                className={`${CLASS_PREFIX}__image--main`}
                itemProp="image"
                src={image.src}
                alt={image.alt}
              />
            </figure>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

LightboxZoomModal.propTypes = {
  images: PropTypes.array,
  currentImage: PropTypes.number,
  onClickThumbnail: PropTypes.func,
  onClose: PropTypes.func,
};

const LightboxImages = (props) => {
  const { images, currentImage, onClickThumbnail, onClickMain, onClose, isOpen } =
    props;

  if (!images || images.length === 0) return null;

  return (
    <>
      <div className="row product-images">
        <div className="columns">
          <div className="product-slider">
            <Carousel
              onClickThumb={(index) => props.onClickThumbnail(index)}
              onChange={(index) => props.onClickThumbnail(index)}
              selectedItem={props.currentImage}
              showThumbs={true}
              showStatus={false}
              showIndicators={false}
              showArrows={!isOpen}
            >
              {images.map((image, index) => (
                <figure
                  className={`product-image ${
                    currentImage == index ? 'active' : ''
                  }`}
                  key={index}
                >
                  <img
                    className="product-detail__image--alter"
                    itemProp="image"
                    src={image.src}
                    alt={image.alt}
                  />
                  <div
                    type="button"
                    disabled={currentImage !== index}
                    className="tiny button padding-1 product-image__zoom"
                    onClick={() => onClickMain(index)}
                  ></div>
                </figure>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      {isOpen ? (
        <LightboxZoomModal
          images={images}
          currentImage={currentImage}
          onClickThumbnail={onClickThumbnail}
          onClickMain={onClickMain}
          onClose={onClose}
        />
      ) : null}
    </>
  );
};

export default LightboxImages;

LightboxImages.propTypes = {
  images: PropTypes.array,
  currentImage: PropTypes.number,
  onClickThumbnail: PropTypes.func,
  onClickMain: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};
